import { ArrowUpRight } from "lucide-react";
import { SKUNK_URL } from "@/data";

const tags = ["Builds", "Parts", "Limited Runs", "Workshop"];

const SkunkMachine = () => (
  <section
    id="skunk-machine"
    data-testid="section-skunk-machine"
    className="relative overflow-hidden bg-black text-white grain"
  >
    <div className="relative z-10 mx-auto max-w-[1600px] px-5 sm:px-8 py-32 sm:py-48">
      {/* Text column */}
      <div className="lg:w-[52%]">
        <img
          data-testid="skunk-logo"
          src="/skunk-machine-logo.webp"
          alt="Skunk Machine — Bespoke Design Services"
          className="mb-10 w-[280px] sm:w-[360px] max-w-full h-auto"
        />
        <span className="text-white/50 text-[11px] sm:text-xs font-bold uppercase tracking-[0.32em]">
          The Sub-Brand — Motorcycles
        </span>

        <h2 className="mt-4 font-head text-3xl sm:text-4xl lg:text-5xl font-medium uppercase kern-tight leading-none text-white">
          Skunk Machine
        </h2>

        <p className="mt-10 max-w-xl text-white/70 text-base sm:text-lg leading-relaxed">
          Motorcycle builds and parts — a workshop-born sister marque to Cerra
          Design. Hand-built machines, technical parts, and limited runs.
        </p>

        <div className="mt-8 flex flex-nowrap items-center gap-x-2.5 sm:gap-x-5 gap-y-3">
          {tags.map((t, i) => (
            <span key={t} className="flex items-center gap-x-2.5 sm:gap-x-5">
              <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.08em] sm:tracking-[0.18em] text-white/80 whitespace-nowrap">
                {t}
              </span>
              {i < tags.length - 1 && (
                <span className="inline-block h-1.5 w-1.5 shrink-0 bg-[var(--orange)]" />
              )}
            </span>
          ))}
        </div>

        <a
          data-testid="skunk-visit-link"
          href={SKUNK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-12 inline-flex items-center gap-3 bg-[var(--orange)] hover:bg-[var(--orange-hover)] text-white text-xs font-bold uppercase tracking-[0.22em] px-8 py-5 transition-colors duration-300"
        >
          Visit Skunk Machine
          <ArrowUpRight
            size={18}
            className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </a>
      </div>

      {/* Video — mobile (in-flow) */}
      <div className="mt-12 lg:hidden">
        <video
          data-testid="skunk-video-mobile"
          src="/skunk-video.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-auto object-cover"
        />
      </div>
    </div>

    {/* Video — desktop (10% inset top/bottom, right side) */}
    <video
      data-testid="skunk-video"
      src="/skunk-video.mp4"
      autoPlay
      loop
      muted
      playsInline
      className="hidden lg:block absolute top-[10%] right-8 h-[80%] w-auto max-w-[48%] object-contain z-10"
    />
  </section>
);

export default SkunkMachine;
